export const environment = {
  production: false,
  auth: {
    clientId: '64449e6b-8db6-4d96-bb9f-3ccc1e8b1831',
    tenantId: 'c55fab4a-533e-46bb-a450-768de6e9d931',
    redirectUri: 'https://dev.aihub.developmeridian.com/',
    apiBaseUrl: 'https://dev.aihub.developmeridian.com',
    apiScope: 'api://55c95d25-fb9d-41eb-ad58-c31d45af0255/ApiAccess',
  },
};
